// src/pages/LandingPage.jsx (or src/LandingPage.jsx)

import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import GetStarted from "./GetStarted";
import FeaturesSection from "./FeaturesSection";
import WhySkillMatchAI from "./WhySkillMatchAI";
import ChooseYourPlan from "./ChooseYourPlan";
import TestimonialsSection from "./TestimonialsSection";
import FAQSection from "./FAQSection";
import StartBuildingSection from "./StartBuildingSection"; // <-- Import the new component

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Header />
      <main className="flex-grow">
        <GetStarted />
        <FeaturesSection />
        <WhySkillMatchAI />
        <ChooseYourPlan />
        <TestimonialsSection />
        <FAQSection />
        <StartBuildingSection />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;
